import api from '@/rest-api'

export default {
    getAbout() {
        return api.get(`/about`)
    },
    
    editAbout(data) {
        return api.post(`/about/edit`, data)
    }
}